import {useLocation} from 'react-router-dom';
import {breadcrumbNameMap} from "./Constants";
import ReactGA from "react-ga4";
import {useEffect} from "react";

// NEW: helper to create/update a meta[name=...] tag
function upsertMeta(name, content) {
    let el = document.querySelector(`meta[name='${name}']`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content ?? "");
}

function upsertPropertyMeta(property, content) {
    let el = document.querySelector(`meta[property='${property}']`);
    if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
    }
    el.setAttribute("content", content ?? "");
}

function upsertCanonical(href) {
    let el = document.querySelector("link[rel='canonical']");
    if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", "canonical");
        document.head.appendChild(el);
    }
    el.setAttribute("href", href);
}

// Central route-change hook
export default function ScrollToTop() {
    const {pathname} = useLocation();

    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: "smooth"});
        // UPDATE META on every navigation
        setPageMeta();
    }, [pathname]);

    return null;
}

/** Sets page metadata based on breadcrumbNameMap and sends pageview to GA. */
export function setPageMeta(pageMetaData) {
    const pathName = window.location.pathname;
    const page = breadcrumbNameMap[pathName] || {};
    const pageMeta = pageMetaData ?? page.pageMeta ?? {};

    if (!pageMeta.title && page.title) {
        document.title = page.title;
    }
    if (pageMeta.title) {
        document.title = pageMeta.title;
    }

    ReactGA.send({
        hitType: "pageview",
        page: pathName + window.location.search,
        title: document.title
    });

    if (pageMeta.description) upsertMeta("description", pageMeta.description);
    if (pageMeta.keywords) upsertMeta("keywords", pageMeta.keywords);

    // default robots if not provided
    upsertMeta("robots", pageMeta.robots || "index, follow");

    const canonical = window.location.origin + pathName;
    upsertCanonical(canonical);
    upsertPropertyMeta("og:title", document.title);
    if (pageMeta.description) upsertPropertyMeta("og:description", pageMeta.description);
    upsertPropertyMeta("og:url", canonical);
    upsertPropertyMeta("og:type", "website");
}
